import type { ListParams } from '../type';
import baseKey from './_baseKey';

const noticeDomainKey = (noticeSubDomains?: (string | number)[]) =>
  baseKey.domainKey('notice', noticeSubDomains);

/**
 * 공지 관련 쿼리키 제너레이터
 */
const noticeKey = {
  /**
   * @returns 공지 도메인 기본 쿼리키 (getter)
   * @example ['notice']
   */
  domain() {
    return noticeDomainKey();
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 페이지네이션 방식 공지 리스트 데이터 요청 쿼리키
   * @example ['notice', 'list', 'page', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    const coreKey = baseKey.listKey(noticeDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  listByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(noticeDomainKey(), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @returns 전체 공지 대상 리스트 데이터 요청 쿼리키
   * @example ['notice', 'target', 'list', 'all']
   */
  targetListAll() {
    return [...baseKey.listKey(noticeDomainKey(['target']), 'all')];
  },
  /**
   * @param id 공지 리스트 아이템 ID
   * @returns 공지 상세 데이터 요청 쿼리키
   * @example ['notice', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(noticeDomainKey(), 'detail'), id];
  },
};

export default Object.freeze(noticeKey);
